import React from "react";

const DeadSeaFacialIng = () => {
  return (
    <div className="organicFacialWhy">
      <h3>Ingredients in Dead Sea Mineral Facial Services in Bangalore</h3>
      <p>
        The success of our Dead Sea Mineral Facial Services in Bangalore lies in
        the high-quality ingredients we use. Here are some key components:
      </p>
      <ul>
        <li>
          <span>Dead Sea Mud:</span> Rich in minerals, Dead Sea mud helps to
          detoxify, hydrate, and nourish the skin.
        </li>
        <li>
          <span> Dead Sea Salt:</span> This salt is known for its exfoliating
          properties, which help to remove dead skin cells and reveal a fresher
          complexion.
        </li>
        <li>
          <span>Magnesium:</span> Essential for maintaining the skin’s moisture
          balance and reducing inflammation.
        </li>
        <li>
          <span>Calcium:</span> Helps to strengthen the skin’s barrier and
          promote cell regeneration.
        </li>
        <li>
          <span>Potassium:</span> Balances moisture levels and helps to maintain
          healthy skin.
        </li>
        <li>
          <span>Bromide:</span> Soothes the skin and reduces redness and
          irritation.
        </li>
      </ul>
    </div>
  );
};

export default DeadSeaFacialIng;
